import { PropsWithChildren } from 'react';
import { NullState } from '../null-state/NullState';

export function NoResults(p: PropsWithChildren<object>) {
  return (
    <NullState className="p-7">
      <div className="mb-4">{p.children}</div>
    </NullState>
  );
}
